import React from 'react';
import { useCarouselStoreForSequence } from '../carousel/CarouselStore';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { CAROUSEL_BACK } from '../itemIds';

import audioEffect from '~/assets/mp3/light_switches.mp3';
import flipEffect from '~/assets/mp3/card_flip.mp3';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { useEditorStore } from '~/shell/Store';

const selector = (s: TrainingState) => select(s, 'auditoryFeedback');

const cardFlipAudioEffect = new Audio(flipEffect);
const audio = new Audio(audioEffect);
cardFlipAudioEffect.load();
audio.load();

interface Props {
  carouselId?: string;
}

export type CarouselBacktDefinition = ItemDefinition<
  typeof CAROUSEL_BACK,
  void | Props
>;

export class CarouselBack extends Item<typeof CAROUSEL_BACK, void | Props> {
  protected render({
    parent,
    carouselId
  }: RenderProps<void | Props> & { carouselId?: string }) {
    if (!carouselId && !parent?.id) {
      throw new Error(
        'CarouselBack must have a carouselId or parent with an id'
      );
    }
    const sequenceId = carouselId || parent?.id || '';
    const { prev, variant } = useCarouselStoreForSequence(sequenceId);
    const { auditoryFeedback } = useTrainingStore(selector);
    const { editorMode } = useEditorStore();

    const onClick = () => {
      if (auditoryFeedback && !editorMode) {
        audio.play().catch(() => {
          // Silently ignore autoplay restrictions
        });
        cardFlipAudioEffect.play().catch(() => {
          // Silently ignore autoplay restrictions
        });
      }

      prev();
    };

    if (variant === 'grid' || variant === 'dynamic') return null;

    return <CloseButton ariaLabel={'back'} onClick={onClick} />;
  }
}

registry[CAROUSEL_BACK] = CarouselBack;
